module.exports = __webpack_public_path__ + "static/energy_9-b8ab8a49771bd1e5ad94cfadc8ab4d83.jpg";